// import { conference } from '@/api';
import { request } from "./request";
import {
  AnyType,
  PlatformEnum,
  MethodEmun,
  Commond,
  ConfefenctType,
  ConferenceInterface,
} from "@/types";
import * as config from "@/config/const";

interface OrderListProps {
  pageNum: number; //	分页页码
  pageSize: number; //条数
  param: any; //查询参数
}
//4、预约会议列表
export const orderList: (p: OrderListProps) => Promise<AnyType> = (params) =>
  request({
    url: "/confmgr/conference/order/list",
    params,
    method: MethodEmun.post,
  });

interface ClientInfoProps {
  productId: string | number; //产品ID
  clientClassifyId: string | number; //分类ID
}
// 6、获取指定client的最新版本信息
// url go 代码无
export const clientInfo: (p: ClientInfoProps) => Promise<AnyType> = ({
  productId,
  clientClassifyId,
}) =>
  request({
    url: `/updatemgr/client/client/${productId}/${clientClassifyId}/clientInfo?clientVersion=`,
  });

interface HistoryListProps {
  pageNum: number; //	分页页码
  pageSize: number; //条数
  param: any; //查询参数
}

//7、历史会议列表
export const historyDetail: (p: HistoryListProps) => Promise<AnyType> = (
  params
) =>
  request({
    url: "/confmgr/conference/history/detail",
    params,
    method: MethodEmun.post,
  });

interface TodayListProps {
  pageNum: number; //	分页页码
  pageSize: number; //条数
  param: any; //查询参数
}

//8、今日列表
export const todayList: (
  p: TodayListProps
) => Promise<Array<ConfefenctType>> = (params) =>
  request({
    url: "/confmgr/conference/today/list",
    params,
    method: MethodEmun.post,
  });

interface ConferenceCreateProps {
  title: string; //会议名称
  beginTime: string; //开始时间  yyyy-MM-dd HH:mm:ss
  endTime: string; //结束时间 yyyy-MM-dd HH:mm:ss
  allowEarlyEntry: number; //是否允许提前进入1是，0 否；默认是
  muteJoinMeeting: number; //成员加入会议静音，1是，0否；默认1
  playTips: number; //成员加入会议时播放提示音，1是，0否；默认0
  allowSelfUnmute: number; //允许成员自我解除静音，1是，0否，默认1
  passwordEnable: number; //是否开启入会密码，0否，1是，默认0
  password?: string; //会议密码
  ownerPassword?: string; //主持人密码
  useSelfConference: number; //是否使用个人会议号   1:是 0：否，默认0
  type: number; //会议类型：1：预约会议   2：即时会议
  agendaId?: string; //议程id
  conferenceNo?: string; // 自己加的，会议id
}
//快速会议的创建时间里面的结束时间是错误的
//9、创建会议
export const conferenceCreate: (
  p: ConferenceCreateProps
) => Promise<ConferenceInterface> = (params) =>
  request({
    url: "/confmgr/conference/create",
    params,
    method: MethodEmun.post,
  });

interface ConferenceJoinHeaderProps {
  "X-Conference-No": string | number; //	${conferenceNo}	会议号
  "X-Device": string | number; //	88877666	android_1.0.1  端_版本信息，端值分别为1 Windows、2 Mac、3 Android、4  IOS
}
interface ConferenceJoinProps {
  conferenceNo?: string; //	会议号,（1）会议号是纯数字字符，（2）只能在9-10位长度
  userName: string; //名称；（1）登录用户默认采用登录用户名，游客自己输入
  password?: string; //会议密码
  closeConference?: boolean; //Owner 是否关闭正在召开的会议, false 否，true 是，默认false
}
// 10、加入会议 此处从后端获取主持人角色
export const conferenceJoin: (
  p: ConferenceJoinProps,
  h: ConferenceJoinHeaderProps
) => Promise<AnyType> = (params, headers) =>
  request({
    url: "/confmgr/conference/join",
    params,
    headers,
    method: MethodEmun.post,
  });

type ConferenceModify = Omit<
  ConferenceCreateProps,
  "useSelfConference" | "type" | "agendaId"
> & { conferenceId: string | number };

// 11、修改会议
export const conferenceModify: (
  p: ConferenceModify
) => Promise<ConfefenctType> = (params) => {
  const { conferenceId, ...otherParams } = params;
  return request({
    url: `/confmgr/conference/updateConferenceInfo/${conferenceId}`,
    params: otherParams,
    method: MethodEmun.put,
  });
};
interface ConferenceLeaveProps {
  roomId: string | number; //房间号
  peerId: string | number; //用户id
}
export const leaveConference: (p: string | number, userId : string, conferenceToken:string, conferNo:string) => Promise<AnyType> = (roomId, userId,conferenceToken,conferNo) => {
  return request({
    url: `/qrtc-conference/conference/leave`,
    params: {
       "roomId":roomId,
       "peerId":userId,
       "conferenceToken":conferenceToken,
       "conferenceNo":conferNo
      
      },
    method: MethodEmun.post,
  });
}
export const updateEndTime: (p: string | number, endTime:string) => Promise<AnyType> = (roomId, endTime) => {
  return request({
    url: `/confmgr/conference/updateEndMeetingTime`,
    params: {
       "roomId":roomId,
       
       "endTime":endTime
      },
    method: MethodEmun.post,
  });

}
export const countOngoingUserAmt:(c: string, r:string) => Promise<AnyType> = (conferenceNo,roomId)=>{
  return request({
    url: `/statisticsusers/ongoing/getUsersAmt/${conferenceNo}/${roomId}`,
    params: {
       "conferenceNo":conferenceNo,
       "roomId":roomId
      },
    method: MethodEmun.post,
  });
}
// 11、强制结束
export const forceEnd: (p: string | number) => Promise<AnyType> = (roomId) => {
  return request({
    url: `/confmgr/conference/force/end/${roomId}`,
    method: MethodEmun.post,
  });
};
// 12、雪花算法
export const snowflakeGet: (p: string | number) => Promise<AnyType> = (key) => {
  return request({
    url: `/tools/api/snowflake/get/${key}`,
  });
};

interface UploadFileHeaderProps {
  appId: string | number; //		app标识
  appVersion: string | number; //	版本号
  buildVersion: string | number; //		构建版本
  deviceId: string | number; //	设备号
  platform: PlatformEnum; //	平台: android  iOS  windows  mac
  unionId: string | number; //	用户标识
  roomId: string | number; //	房间号（非必须）
  userName?: string; //		用户名（非必须）
  source: string; //	来源  例如：ybmeet，ybswticher
}

// 12、上传日志
export const uploadFile: (h: UploadFileHeaderProps) => Promise<AnyType> = (
  headers
) => {
  return request({
    url: `/logmgr/uploadFile`,
    method: MethodEmun.post,
    headers,
    withDefaultHeader: false,
  });
};

interface ConferencePersonProps {
  conferenceNo: string | number; //个人会议号
  password?: string; //  会议密码
  allowEarlyEntry?: number; //	  是否允许提前进入 1：是；0否
  agendaPermission?: number; //  会议议程权限 0：所有人可见 1：仅主持人可见
  passwordEnable?: number; //  是否开启入会密码  0 关闭，默认；1 开启
  muteJoinMeeting?: number; //  成员加入会议静音 1：是；0否；
  playTips?: number; //  成员加入会议时播放提示因1：是；0否；
  allowSelfUnmute?: number; //  允许成员自我解除静音;1是；0：否
  ownerPasswordEnable?: number; //	  是否开启个人会议号主持人密码  0 关闭，默认；1 开启
  ownerPassword?: string; //  个人会议号主持人密码
}

// 13、更新个人信息
export const conferencePerson: (
  p: ConferencePersonProps
) => Promise<AnyType> = (p) => {
  const { conferenceNo, ...params } = p;
  return request({
    url: `/confmgr/conference/person/${conferenceNo}`,
    method: MethodEmun.put,
    params,
  });
};

// 14、导出参会人明细
export const detailExport: (p: string | number) => Promise<AnyType> = (
  conferenceId
) => {
  return request({
    url: `/confmgr/enterprise/conference/${conferenceId}/detail/export`,
    method: MethodEmun.post,
  });
};

interface ConferenceControlHeaderProps {
  "X-Channel-Token": string | number; //	${access_token}	 IM的token
  "X-Conference-Token": string | number; //	${access_token} 会议服务的token
  "X-Conference-No": string | number; //	${conferenceNo}	会议号
}

interface PeerProps {
  peerid: string; //
  deviceid?: string | number; //设备号
}

interface ConferenceControlProps {
  command: Commond;
  metadata: string | number; //元信息（具体执行的命令对应的参数）
  seq: string; //客户端生成的序列号
  room?: string; //房间号
  to?: Omit<PeerProps, "deviceid">; //被操作人信息	   备注: 被操作人信息
  from?: PeerProps; //操作人信息
}

//比对主持人密码
export const compareHostPwd:  (
  conferenceNo: string,
  ownerPassword: string,
  h: ConferenceControlHeaderProps) => Promise<AnyType> = (conferenceNo,ownerPassword, headers) => {
  ///${conferenceNo}/${password}
  let params = {
    conferenceNo: conferenceNo,
    ownerPassword:ownerPassword
  }
  return request({
    url: `/confmgr/conference/compareHostPwd`,
    params,
    method: MethodEmun.post,
  });

}
export const checkPlayTips: (p: string) => Promise<AnyType> = (conferenceNo) => {
   return request({
    url: `/confmgr/conference/nologin/${conferenceNo}`,
    method: MethodEmun.get,
   }).catch((e) => {})
}
// 15、会控管理
export const conferenceControl: (
  p: ConferenceControlProps,
  h: ConferenceControlHeaderProps
) => Promise<AnyType> = (params, headers) => {
  return request({
    url: "/confmgr/conference/control",
    params,
    method: MethodEmun.post,
    headers: { ...headers, "Content-Type": config.CONTENTTYPE },
  });
};

// 16、删除历史会议
export const conferenceRoom: (p: string) => Promise<AnyType> = (rtcRoomNo) =>
  request({
    url: `/confmgr/conference/delroom/${rtcRoomNo}`,
    params:{conferenceId:rtcRoomNo},
    method: MethodEmun.post,
  });

type ReconnectionHeaderProps = Omit<
  ConferenceControlHeaderProps,
  "X-Conference-No"
>;
interface ReconnectionProps {
  userId: string; //    用户id
  deviceId: string; //    设备id
  conferenceNo?: string; //    会议号
  roomId: string; //    房间号
}
// 17、断线重连
export const reconnection: (
  p: ReconnectionProps,
  h: ReconnectionHeaderProps
) => Promise<AnyType> = (params, headers) => {
  return request({
    url: "/confmgr/conference/reconnection",
    params,
    headers: { ...headers, "Content-Type": config.CONTENTTYPE },
    method: MethodEmun.post,
    withDefaultHeader: false,
  });
};

// 18、获取owner进行中的会议信息
export const conference: () => Promise<AnyType> = () =>
  request({
    url: `/confmgr/conference/owner/inprogress/conference/`,
  });

// 23、删除预约会议
export const conferenceDelete: (p: string) => Promise<AnyType> = (id) =>
  request({
    url: `/confmgr/conference/${id}`,
    method: MethodEmun.delete,
  });
